export default {
    //ProductList
    your_created_projects: "Your created courses",
    new_project: "New Course",
    projects_name: "COURSE NAME",
    update_at: 'Updated on ',
    coming_soon: 'Coming soon',
    search_your_project: 'Search for your course...',
    project_name: 'Course name',
    loading_products: 'Loading products...',

    //ProductEditComponent
    modify_project: 'Modifying your projects',
    general: 'General',
    branding: 'Branding',
    product_page: 'Product Page',
    sale: 'Sale',
    seo_text: 'SEO',
    projects: 'Projects',

    //CategoriesSlideOverComponent
    categories: 'Categories',
    text_category: 'Classify your products by category to make it easier for your students to buy your courses.',
    select_category: 'Select category...',
    ebook: 'E-book',
    online_project: 'Online projects',
    blended_learning: 'Blended learning projects',
    online_program: 'Online Programme',
    webinar_consulting: 'Webinar / Online consulting',
    remove_category: 'Remove category',
    href_help: 'More about the categories',

    //ProductEdit
    //CustomCategoriesComponent
    //GeneralComponent
    category: 'Category',
    duration: 'Duration',
    featured_product: 'Product Spotlight',
    delete_project: 'Delete projects',
    warning_delete: 'Warning!',
    message_delete_project: 'By deleting the projects you will permanently lose all your data.',
    question_delete_project: 'Are you sure you want to delete this projects?',
    delete: 'Delete',
    confirmation_delete_project: '(*) This box is required to delete the projects.',
    //PageComponent
    principal_page: 'Home Page',
    objectives_presentation: 'Presentation and objectives',
    learning_objectives: 'Don\'t forget to briefly describe the learning objectives.',
    teaching_staff: 'Methodology and teaching staff',
    public: 'Public',
    content: 'Content',
    sidebar: 'Side Bar',
    //ProductBrandingComponent
    banner: 'Banner',
    upload_banner: 'Upload your banner',
    banner_format: 'PNG, JPG, GIF up to 3MB',
    promotional_video: 'Promotional Video',
    video_url: 'Video URL',
    video_info: 'If you have a promotional video, place here the url of the video on Youtube or Vimeo.',
    //SellComponent
    price_management: 'Price Management',
    sell_price: 'Selling price',
    tax: 'In €. (-3% tax)',
    price_offer: 'Offer Price',
    text_configuration: 'Text configuration',
    free_text_button: 'Free buy button title',
    text_if_free: 'This title will appear if your product is free',
    on_sale: 'For sale',
    sale_info: 'If activated your product will be for sale',

    //SeoComponent
    seo_configuration: 'SEO Configuration',
    seo_title: 'SEO Title',
    slug: 'Slug',
    seo_description: 'SEO Description',

    //ProjectListComponent
    featured: 'Featured',
    classroom: 'Classroom',
    slug_text: 'slug',
    product: 'product',
    products: 'products',
    preview: 'Preview',

    //AttachProjectSlideOverComponent
    attach_project: 'Associate Project',
    loading_projects: 'Loading associated projects...',
    project_selected: 'Selected project',
    quest_attach_project: 'Do you want to attach this project?',
    back: 'Back',
    add_project: 'Attach Project',
    close_panel: 'Close panel',

    //ProjectAttachedListComponent
    attached_projects: 'Associated Projects',
    loading_products_attached: 'Loading associated products...',
    unattach_project: 'Disassociate project',
    info_unattach_project: 'By disassociating the project from the product, students who purchase the product will not be able to access the project.',
    quest_unattach_project: 'Are you sure you want to disassociate the project ',

    // ProductList · paginación y estados
    search_label: 'Search courses',
    actions: 'Actions',
    edit_product: 'Edit course',
    load_error: 'The courses could not be loaded.',
    retry: 'Try again',
    no_results_title: 'No courses match "{search}"',
    no_results_text: 'Try another name or check the spelling.',
    clear_search: 'Clear search',
    empty_title: "You haven't created any courses yet",
    empty_text: 'Create your first course to start selling it in your academy.',
    product_published: 'The course has been published',
    product_unpublished: 'The course has been unpublished',
    unexpected_error: 'An unexpected error has occurred',

    // TipTapEditorComponent · menú de bloques (página de producto)
    blocks_menu: 'Blocks',
    blocks_menu_label: 'Insert a predesigned block',
    block_badge: 'Highlighted notice',
    block_key_facts: 'Key facts',
    block_separator: 'Divider',
    block_price_enroll: 'Price and enrolment',

    // BlockControls · controles de cada bloque
    block_move_up: 'Move “{block}” up',
    block_move_down: 'Move “{block}” down',
    block_remove: 'Remove “{block}”',
    block_remove_confirm_title: 'Remove this block?',
    block_remove_confirm_text: 'The block will disappear from the text. You can bring it back with Undo (Ctrl+Z) until you save.',
    block_remove_confirm_action: 'Remove',

    // PriceEnrollNodeView · bloque «Precio e inscripción»
    price_enroll_price: 'Price or text',
    price_enroll_price_placeholder: 'E.g. €1,200 / Subsidised / Free',
    price_enroll_button_text: 'Button text',
    price_enroll_button_url: 'Button link',
    price_enroll_note: 'Note (optional)',
    price_enroll_button_color: 'Button colour',
    price_enroll_url_invalid: 'Enter a link starting with https://, http:// or mailto:',
    price_enroll_no_button: 'Without a valid link, the button will not be shown on the public page.',
    price_enroll_default_button: 'Enrol now',

    // InfoPricesNodeView · bloque «Tarifas informativas»
    block_info_prices: 'Informative prices',
    info_prices_title: 'Title (optional)',
    info_prices_title_placeholder: 'E.g. Labour Inspection module',
    info_prices_row: 'Row {n}',
    info_prices_row_label: 'Label',
    info_prices_row_label_placeholder: 'E.g. Members',
    info_prices_row_amount: 'Amount',
    info_prices_row_amount_placeholder: 'E.g. €360 / Subsidised',
    info_prices_add_row: 'Add row',
    info_prices_remove_row: 'Remove row {n}',
    info_prices_accent_color: 'First row colour',
    info_prices_default_row_1: 'Standard rate',
    info_prices_default_row_2: 'Reduced rate',

    // LinkButtonNodeView · bloque «Botón de enlace»
    block_link_button: 'Link button',
    link_button_default_text: 'More information',
    link_button_text: 'Button text',
    link_button_url: 'Link',
    link_button_url_invalid: 'Enter a link starting with https://, http:// or mailto:',
    link_button_no_link: 'Without a valid link the button is not shown. Add a link starting with https://, http:// or mailto:',
    link_button_color: 'Button colour',
    link_button_variant: 'Style',
    link_button_variant_solid: 'Filled',
    link_button_variant_outline: 'Outline',

    // TipTapEditorComponent · barra de herramientas (FE-054)
    editor_toolbar: 'Text formatting',
    editor_bold: 'Bold',
    editor_italic: 'Italic',
    editor_underline: 'Underline',
    editor_strike: 'Strikethrough',
    editor_heading_2: 'Heading 2',
    editor_heading_3: 'Heading 3',
    editor_heading_4: 'Heading 4',
    editor_bullet_list: 'Bulleted list',
    editor_ordered_list: 'Numbered list',
    editor_align_left: 'Align left',
    editor_align_center: 'Center',
    editor_align_right: 'Align right',
    editor_blockquote: 'Quote',
    editor_code_block: 'Code block',
    editor_link: 'Link',
    editor_remove_link: 'Remove link',
    editor_insert_image: 'Insert image',
    editor_horizontal_rule: 'Horizontal line',
    editor_text_color: 'Text color',
    editor_remove_color: 'Remove color',
    editor_undo: 'Undo',
    editor_redo: 'Redo',
    editor_edit_html: 'Edit HTML',
    editor_insert_badge: 'Insert highlighted notice',
    editor_insert_icon_list: 'Insert icon list',
    editor_insert_raw_html: 'Insert custom HTML (unrestricted)',
    editor_badge_panel: 'Highlighted notice:',
    editor_badge_border: 'Border',
    editor_badge_text: 'Text',
    editor_badge_background: 'Background',
    editor_icon_list_panel: 'Icon list:',
    editor_icon_list_color: 'Icon color',
    editor_link_url: 'Link URL:',
    editor_image_url: 'Image URL:',
    editor_apply: 'Apply',
    editor_cancel: 'Cancel',
    editor_html_source: 'HTML code',
}
